import type { IxcSweepsClearingV1SweepsJobKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const SWEEPS_JOB_BASE_PATH = getResolvedPath('/clearing/operations/sweep/job');

export const getSweepsJobPath: EntityPathBuilder<IxcSweepsClearingV1SweepsJobKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return SWEEPS_JOB_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.sweepsJobId) {
        return undefined;
      }

      return getResolvedPath(`${SWEEPS_JOB_BASE_PATH}/$jobId`, { jobId: context.keys.sweepsJobId, ...context.keys });
    }
  }
};

export function getSweepsJobDetailPath(sweepsJobId: string | undefined) {
  if (!sweepsJobId) {
    return undefined;
  }

  return getSweepsJobPath({ kind: 'detail', keys: { sweepsJobId } });
}
